/* globals $, controller, globalScene, allTweens */

import { Power4, TimelineMax } from 'gsap';
import 'gsap/ScrollToPlugin';

import scrollToSection from 'helpers/scrolling/scrollToSection';
import addScenesForHash from 'helpers/scenes/addScenesForHash';
import toggleParallax from 'helpers/toggleParallax';
import copyHeight from 'helpers/copyHeight';
import resizeThrottler from 'helpers/resizeThrottler';
import updateGlobalScenes from 'helpers/scenes/updateGlobalScenes';

export default function initScroll (hash) {
  let tm = null;

  controller.enabled(false);

  addScenesForHash(controller);

  $(window).on('scroll-play', () => {
    controller.enabled(true);
    scrollToSection('#news', 0.1, true, false);
  });

  $(window).on('scroll-careers', () => {
    scrollToSection('#careers', 0.1, true, false);
  });

  $(window).on('scroll-pause', () => {
    controller.enabled(false);
  });

  const resizeHandler = function () {
    controller.enabled(false);
    window.hashTrack = false;

    $('#master').removeAttr('style');
    copyHeight($(window), $('.top-bar-section'));

    let w = $(window).innerWidth();
    let h = $(window).innerHeight();

    toggleParallax();

    if (!$('html').hasClass('noScroll')) {

      $('#franchises  .parallax ul').css({
        width: w,
        height: h - 75,
        overflow: 'hidden',
        position: 'relative',
      });

      updateGlobalScenes();

      if ($('body').hasClass('loading')) {
        let _tl = new TimelineMax({
          onComplete: () => {
            $('body').removeClass('loading');
            $('.load').remove();
          },
        })
        .fromTo($('.loading .load > div'), 1, {
          scale: 1,
        }, {
          scale: 0,
          ease: Power4.easeInOut,
        })
        .fromTo($('.loading .load'), 2, {
          yPercent: 0,
        }, {
          yPercent: 100,
          ease: Power4.easeInOut,
        }, '=-1')
        .fromTo($('.top-bar'), 2, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          ease: Power4.easeInOut,
          clearProps: 'all',
        }, '=-1');
      }
    } else {
      if ($('body').hasClass('topbar-expanded')) {
        copyHeight($(window), $('.top-bar-section'));
      }
    }

    controller.enabled(true);

    if (tm === null) {

      tm = setTimeout(() => {
        if (typeof hash !== 'undefined' && hash !== null) {
          window.hashTrack = true;
          scrollToSection(hash, true, false, 0.5);
          hash = null;
        } else {
          if (hash !== location.hash) {
            hash = location.hash;
          }

          window.hashTrack = true;
        }
        clearInterval(tm);
        tm = null;

      }, 1000);
    }
  };
  $(window).on('resize', () => resizeThrottler()(resizeHandler, 66));
  resizeHandler();
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scrolling/initScroll.js